import { jwtDecode } from "jwt-decode";
import {
  API_ENDPOINTS,
  HEADER,
  STORAGE_KEYS,
  ENDPOINT_HEADERS,
  PATTERN_HEADERS,
} from "../constants";
import { getSessionStorage } from "./storageUtils";
import packageJson from "../../package.json";

export const isTokenExpired = (token, bufferSeconds = 0) => {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return true;
    const bufferTime = bufferSeconds * 1000; // Convert buffer seconds to milliseconds
    return Date.now() >= exp * 1000 - bufferTime; // Check if token is expired or expires within buffer time
  } catch (error) {
    console.log(error);
    return true; // Invalid token
  }
};

export const isAuthEndpoint = (originalRequest) => {
  const isAuthEndpoint = [
    API_ENDPOINTS.CUSTOMER_EXISTS,
    API_ENDPOINTS.REGISTER_INITIATE,
    API_ENDPOINTS.REGISTER_VERIFY_OTP,
    API_ENDPOINTS.REGISTER_SET_PIN,
    API_ENDPOINTS.LOGIN_INITIATE,
    API_ENDPOINTS.LOGIN_VERIFY_OTP,
    API_ENDPOINTS.LOGIN_SET_PIN,
    API_ENDPOINTS.FORGOT_PASSWORD_INITIATE,
    API_ENDPOINTS.FORGOT_PASSWORD_VERIFY_OTP,
    API_ENDPOINTS.FORGOT_PASSWORD_SET_PIN,
    API_ENDPOINTS.CR_LOGIN,
    API_ENDPOINTS.CUSTOMER_CONSENT,
    API_ENDPOINTS.NAFATH_VERIFICATION,
    API_ENDPOINTS.PARTNER_LOGIN,
    API_ENDPOINTS.DISTRIBUTOR_LOGIN,
    API_ENDPOINTS.DISTRIBUTOR_VERIFY_OTP,
    API_ENDPOINTS.VERIFY_OTP,
  ].some((endpoint) => originalRequest.url.includes(endpoint));

  return isAuthEndpoint;
};

export const isRefreshExcludedEndpoint = (originalConfig) => {
  const refreshExcludedEndpoints = [
    "/api/v1/master-service/tenants/",
    API_ENDPOINTS.REFRESH_TOKEN,
    API_ENDPOINTS.CUSTOMER_EXISTS,
    API_ENDPOINTS.REGISTER_INITIATE,
    API_ENDPOINTS.REGISTER_VERIFY_OTP,
    API_ENDPOINTS.REGISTER_SET_PIN,
    API_ENDPOINTS.LOGIN_INITIATE,
    API_ENDPOINTS.LOGIN_VERIFY_OTP,
    API_ENDPOINTS.LOGIN_SET_PIN,
    API_ENDPOINTS.FORGOT_PASSWORD_INITIATE,
    API_ENDPOINTS.FORGOT_PASSWORD_VERIFY_OTP,
    API_ENDPOINTS.FORGOT_PASSWORD_SET_PIN,
    API_ENDPOINTS.AUTH_BACK_SESSION,
    API_ENDPOINTS.CR_LOGIN,
    API_ENDPOINTS.CUSTOMER_CONSENT,
    API_ENDPOINTS.NAFATH_VERIFICATION,
    API_ENDPOINTS.LOGIN,
    API_ENDPOINTS.LOGIN_CALL_BACK,
    API_ENDPOINTS.PARTNER_LOGIN,
  ];

  return refreshExcludedEndpoints.some((endpoint) => {
    return originalConfig.url.includes(endpoint);
  });
};

export const applyHeaders = (config) => {
  let requiredHeaders = [];

  if (ENDPOINT_HEADERS[config.url]) {
    requiredHeaders = ENDPOINT_HEADERS[config.url];
  } else {
    const matchedPattern = PATTERN_HEADERS.find((entry) =>
      config.url.includes(entry.pattern)
    );
    if (matchedPattern) {
      requiredHeaders = matchedPattern.headers;
    }
  }

  const tenantId = getSessionStorage(HEADER.REQUEST_TENANT);
  const deviceId = getSessionStorage(HEADER.DEVICE_ID);
  const flowId = getSessionStorage(HEADER.FLOW_ID);
  const accessToken = getSessionStorage(HEADER.AUTHORIZATION);
  const refreshToken = getSessionStorage(HEADER.REFRESH_TOKEN);
  const channelId = getSessionStorage(HEADER.CHANNEL_ID);
  const userId = getSessionStorage(HEADER.USER_ID);
  const productSlug = getSessionStorage(HEADER.PRODUCT_SLUG);
  const applicationId = getSessionStorage(HEADER.APPLICATION_ID);
  const preferredLanguage = getSessionStorage(STORAGE_KEYS.PREFERED_LANGUAGE);

  requiredHeaders.forEach((header) => {
    if (header === HEADER.DEVICE_ID && deviceId) {
      config.headers[HEADER.DEVICE_ID] = deviceId;
    }
    if (header === HEADER.FLOW_ID && flowId) {
      config.headers[HEADER.FLOW_ID] = flowId;
    }
    if (header === HEADER.AUTHORIZATION && accessToken) {
      config.headers[HEADER.AUTHORIZATION] = `Bearer ${accessToken}`;
    }
    if (header === HEADER.REFRESH_TOKEN && refreshToken) {
      config.headers[HEADER.REFRESH_TOKEN] = refreshToken;
    }
    if (header === HEADER.CONNECT_AUTH_API_KEY) {
      config.headers[HEADER.CONNECT_AUTH_API_KEY] =
        process.env.REACT_APP_CONNECT_API_KEY;
    }
  });

  // Default Headers
  config.headers[HEADER.REQUEST_TENANT] = tenantId;
  config.headers[HEADER.CHANNEL_ID] = channelId;
  config.headers[HEADER.USER_ID] = userId;
  config.headers[HEADER.PRODUCT_SLUG] = productSlug;
  config.headers[HEADER.APPLICATION_ID] = applicationId;
  config.headers[HEADER.APP_VERSION] = packageJson.version;
  config.headers[HEADER.ACCEEPT_LAGUAGE] = preferredLanguage;

  return config;
};

export const isSpecialFlowEndpoint = (originalRequest) => {
  const url = originalRequest?.url || "";

  const financeNextTaskPattern = /\/requests\/\d+\/next-task(?:\?.*)?$/;
  const completeFinancePattern =
    /\/requests\/\d+\/tasks\/\d+\/complete(?:\?.*)?$/;

  // CR Login endpoints
  const authFlowPattern =
    /\/customer-service\/(cr-login\/(initiate|verify-otp)|auth\/distributor\/(otp-verify|login))/;

  const isFinanceEndpoint =
    financeNextTaskPattern.test(url) ||
    completeFinancePattern.test(url) ||
    url.includes(API_ENDPOINTS.LOGIN_CALL_BACK) ||
    authFlowPattern.test(url);

  return isFinanceEndpoint;
};
